export const colors = {
  navy: {
    50: '#71778F',
    100: '#59607D',
    200: '#41496A',
    300: '#2A3358',
    DEFAULT: '#121C45',
    500: '#10193E',
    600: '#0E1637',
    700: '#0D1430',
    800: '#090936',
  },
  periwinkle: {
    50: '#85A1DF',
    100: '#7092D9',
    200: '#5C82D4',
    300: '#4773CE',
    DEFAULT: '#3363C9',
    500: '#2E59B5',
    600: '#294FA1',
    700: '#24458D',
    800: '#1F3B79',
  },
  lightBlue: {
    50: '#EFF7F8',
    100: '#E6F3F4',
    200: '#DEEFF0',
    300: '#D6EBEC',
    DEFAULT: '#ADD6D9',
    500: '#8AABAE',
    600: '#688082',
    700: '#455657',
    800: '#232B2B',
  },
  grayBlue: {
    25: '#F6F8FA',
    50: '#E7EDF1',
    100: '#CEDAE3',
    200: '#B6C8D6',
    300: '#AABFCF',
    DEFAULT: '#85A3BA',
    500: '#6A8295',
    600: '#506270',
    700: '#35414A',
    800: '#1B2125',
  },
  green: {
    50: '#66C0A3',
    100: '#4DB694',
    200: '#33AB85',
    300: '#1AA175',
    DEFAULT: '#009666',
    500: '#00875C',
    600: '#007852',
    700: '#006947',
    800: '#005A3D',
  },
  red: {
    25: '#FFEBEB',
    50: '#E98E8F',
    100: '#E67B7D',
    200: '#DF5558',
    300: '#DF5558',
    DEFAULT: '#DB4245',
    500: '#C53B3E',
    600: '#AF3537',
    700: '#992E30',
    800: '#832829',
  },
  darkTan: {
    50: '#F4F0ED',
    100: '#E3D9D1',
    200: '#D8C9BF',
    300: '#D2C1B5',
    DEFAULT: '#C7B2A3',
    500: '#9F8E82',
    600: '#776B62',
    700: '#504741',
    800: '#282421',
  },
  tan: {
    10: '#E1D9CB',
    50: '#FCF8F3',
    100: '#F1ECE4',
    150: '#EDE8E3',
    200: '#EEE8DF',
    300: '#EBE4D9',
    350: '#E1D9CB',
    DEFAULT: '#E3D9C9',
    500: '#B6AEA1',
    600: '#888279',
    700: '#5B5750',
    800: '#2D2B28',
  },
  neutral: {
    0: '#FFFFFF',
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#EEEEEE',
    300: '#E0E0E0',
    400: '#BDBDBD',
    500: '#9E9E9E',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    1000: '#0A0A0A',
  },
  warn: {
    50: '#FFF4E2',
    100: '#FFE0B2',
    200: '#FECD81',
    300: '#FEB84E',
    400: '#FEA827',
    500: '#FF9F29',
    600: '#ED0017',
    700: '#D66F03',
    800: '#B55E22',
    900: '#8D3811',
  },
  success: {
    50: '#EAFBE6',
    100: '#CBF4C1',
    200: '#A6EC98',
    300: '#7CE36A',
    400: '#52DC43',
    500: '#00D504',
    600: '#00C400',
    700: '#00A300',
    800: '#008500',
    900: '#006100',
  },
  error: {
    50: '#FFE9EC',
    100: '#FFC8CC',
    200: '#F7918E',
    300: '#EF6462',
    400: '#F83A39',
    500: '#FC1B13',
    600: '#ED0017',
    700: '#DC0011',
    800: '#C40107',
    900: '#A30000',
  },
  white: '#FFFFFF',
  black: '#333333',
  transparent: 'transparent',
  current: 'currentColor',
}
